@app.directive 'bannerPremiumPaywall', (PricingService, AnalyticsService) ->
  restrict: 'E'
  scope: {}
  controllerAs: 'bannerPremiumPaywall'
  replace: true
  controller: ->

    @trackMoreInfo = ->
      AnalyticsService.track 'Banner Clicked', {name: 'bannerPremiumPaywall'}

    @price = PricingService.getPrice(PricingService.PREMIUM_SKU, {userIsPremium: false, usedCirculatorDiscount: false}).price

    this

  link: (scope, element, attrs) ->

  bindToController: {
    theme: '='
    content: '='
  }
  templateUrl: "/assets/templates/components/banner/bannerPremiumPaywall/bannerPremiumPaywall.html"
